<div *ngIf="chips">
	<div class="section-header" *ngIf="showHeader" data-testid="milk_bottle_inventory__header">
		Patient Inventory
	</div>

	<ng-container *ngFor="let chip of chips; let i = index" >
		<ion-chip [disabled]="true" [ngClass]="chip.cssClass" [attr.data-testid]="'milk_bottle_inventory__chip_' + i">
			<ion-label>{{ chip.value }} {{ chip.label }}</ion-label>
		</ion-chip>
	</ng-container>
</div>
